import type { BookingOffering, LessonCreditBlock, LessonCreditSummary } from "./api.js";

/** Navigation context only. The booking page revalidates this against scoped server reads. */
export function creditBookingLink(studentId: string, blockId: string): string {
  return `/book?${new URLSearchParams({ student: studentId, credit_student: studentId, credit: blockId })}`;
}

export function resolveCreditBooking(
  studentId: string,
  blockId: string,
  credits: LessonCreditSummary | null,
  offerings: readonly BookingOffering[],
): { block: LessonCreditBlock; offering: BookingOffering } | null {
  if (credits?.portal_student_id !== studentId) return null;
  const block = credits.blocks.find((item) => item.lesson_block_id === blockId);
  if (!block || block.available_credits <= 0 || !block.booking.allowed) return null;
  const offering = offerings.find((item) =>
    item.provider_id === block.provider_id && item.service_id === block.service_id &&
    item.lesson_block_ids.includes(blockId) && item.book_with_credit.allowed && item.available_credits > 0,
  );
  return offering ? { block, offering } : null;
}

/** A compact reference disambiguates same-name, same-day purchases. */
export function creditBlockReference(id: string): string {
  return id.replace(/[^a-z0-9]/gi, "").slice(-6).toUpperCase();
}
export function creditDetailsLink(studentId?: string | null, blockId?: string | null): string {
  const query = new URLSearchParams({ tab: "credits" });
  if (blockId) query.set("block_id", blockId);
  if (studentId) query.set("student", studentId);
  return `/history?${query}`;
}
